"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarPreview = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/components/site-menu/component");
const backendImport_1 = require("@front/backendImport");
const voices_helper_1 = require("@front/helpers/voices.helper");
const component_2 = require("@front/layouts/default-layout/component");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
const console_1 = require("@rws-framework/console");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
  <div class="avatar-preview-page">
    <div class="row">
      <div class="col-lg-12 col-12 pb-lg-5">
        <div class="mb-2">
          <h1>${'avatar.preview.title'.t()}</h1>
          <div class="text-zero top-right-button-container">
            <button @click="${(x, c) => x.edit()}" type="button"
              class="top-right-button mr-2 btn btn-primary btn-lg" ?disabled="${x => !x.avatarId}">
              ${'avatar.preview.edit'.t()}
            </button>
            <button @click="${(x, c) => x.back()}" type="button"
              class="top-right-button btn btn-primary btn-lg">
              ${'avatar.preview.back'.t()}
            </button>
          </div>
        </div>

        ${(0, fast_element_1.when)(x => x.avatar, (0, fast_element_1.html) `        
          
          <div class="row mb-4">
            
            <div class="col-lg-8 mb-3">
              <div class="card shadow-sm h-100">
                <div class="card-body">
                  <h5 class="card-title text-secondary mb-4">
                    <i class="simple-icon-people mr-2"></i>
                    ${'avatar.preview.section.basic_info'.t()}
                  </h5>
                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 mr-3">
                          <div class="icon-circle bg-light text-muted">
                            <i class="simple-icon-user"></i>
                          </div>
                        </div>
                        <div>
                          <small class="text-muted d-block">${'avatar.form.name.label'.t()}</small>
                          <strong>${x => { var _a; return ((_a = x.avatar) === null || _a === void 0 ? void 0 : _a.name) || 'avatar.preview.not_provided'.t(); }}</strong>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 mb-3">
                      <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 mr-3">
                          <div class="icon-circle bg-light text-muted">
                            <i class="simple-icon-symbol-male"></i>
                          </div>
                        </div>
                        <div>
                          <small class="text-muted d-block">${'avatar.form.gender.label'.t()}</small>
                          <strong>${x => x.avatar.gender ? ('gender.' + x.avatar.gender).t() : 'avatar.preview.gender.not_selected'.t()}</strong>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 mb-3">
                      <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 mr-3">
                          <div class="icon-circle bg-light text-muted">
                            <i class="simple-icon-calendar"></i>
                          </div>
                        </div>
                        <div>
                          <small class="text-muted d-block">${'avatar.form.age.label'.t()}</small>
                          <strong>${x => { var _a; return ((_a = x.avatar) === null || _a === void 0 ? void 0 : _a.age) || 'avatar.preview.not_provided'.t(); }}</strong>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 mb-3">
                      <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 mr-3">
                          <div class="icon-circle bg-light text-muted">
                            <i class="simple-icon-microphone"></i>
                          </div>
                        </div>
                        <div>
                          <small class="text-muted d-block">${'avatar.form.voice.label'.t()}</small>
                          <strong>${x => x.getSelectedVoiceLabel()}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            
            <div class="col-lg-4 mb-3">
              <div class="card shadow-sm h-100">
                <div class="card-body text-center">
                  <h5 class="card-title text-secondary mb-3">
                    <i class="simple-icon-picture mr-2"></i>
                    ${'avatar.form.logo.label'.t()}
                  </h5>
                  ${(0, fast_element_1.when)(x => { var _a; return (_a = x.avatar) === null || _a === void 0 ? void 0 : _a.logo; }, (0, fast_element_1.html) `
                    <div class="mb-3">
                      <img src="${x => ('/uploads/' + x.avatar.logo.filename).thumb('square-mid')}" alt="Avatar Logo" 
                           class="img-fluid rounded shadow"/>
                    </div>
                    <small class="text-muted">${x => x.avatar.logo.originalname}</small>
                  `, (0, fast_element_1.html) `
                    <div class="text-muted py-4">
                      <i class="simple-icon-picture" style="font-size: 3rem; margin-bottom: 1rem; opacity: 0.5;"></i>
                      <p class="mb-0">${'avatar.preview.logo.not_uploaded'.t()}</p>
                    </div>
                  `)}
                </div>
              </div>
            </div>
          </div>

          
          ${(0, fast_element_1.when)(x => { var _a; return (_a = x.avatar) === null || _a === void 0 ? void 0 : _a.description; }, (0, fast_element_1.html) `
            <div class="card shadow-sm mb-4">
              <div class="card-body">
                <h5 class="card-title text-secondary mb-3">
                  <i class="simple-icon-docs mr-2"></i>
                  ${'avatar.form.description.label'.t()}
                </h5>
                <p class="card-text text-dark mb-0">${x => x.avatar.description}</p>
              </div>
            </div>
          `)}

          
          <div class="card shadow-sm mb-4">
            <div class="card-body">
              <h5 class="card-title text-secondary mb-4">
                <i class="simple-icon-chemistry mr-2"></i>
                ${'avatar.preview.section.ai_model'.t()}
              </h5>
              ${(0, fast_element_1.when)(x => { var _a; return (_a = x.avatar) === null || _a === void 0 ? void 0 : _a.model; }, (0, fast_element_1.html) `
                <div class="row align-items-center">
                  <div class="col-md-8">
                    <div class="d-flex align-items-start">
                      <div class="flex-shrink-0 mr-3">
                        <div class="icon-circle bg-primary text-white">
                          <i class="simple-icon-chemistry"></i>
                        </div>
                      </div>
                      <div class="flex-grow-1">
                        <h6 class="mb-1">${x => x.avatar.model.model.label || x.avatar.model.model.value}</h6>
                        ${(0, fast_element_1.when)(x => x.avatar.model.provider, (0, fast_element_1.html) `
                          <small class="text-muted d-block">${'avatar.preview.provider'.t()}: ${x => x.avatar.model.provider.name}</small>
                        `)}
                        ${(0, fast_element_1.when)(x => x.avatar.model.model.description, (0, fast_element_1.html) `
                          <p class="text-muted small mt-2 mb-0">${x => x.avatar.model.model.description}</p>
                        `)}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 text-md-right mt-3 mt-md-0">
                    ${(0, fast_element_1.when)(x => x.avatar.model.cost, (0, fast_element_1.html) `
                      <span class="badge badge-info badge-lg">
                        <i class="simple-icon-credit-card mr-1"></i>
                        ${x => x.avatar.model.cost}
                      </span>
                    `)}
                  </div>
                </div>
              `, (0, fast_element_1.html) `
                <div class="alert alert-warning mb-0" role="alert">
                  <div class="d-flex align-items-center">
                    <i class="simple-icon-exclamation mr-2"></i>
                    <span>${'avatar.preview.model.not_selected'.t()}</span>
                  </div>
                </div>
              `)}
            </div>
          </div>

          
          ${(0, fast_element_1.when)(x => { var _a, _b; return (_b = (_a = x.avatar) === null || _a === void 0 ? void 0 : _a.model) === null || _b === void 0 ? void 0 : _b.canTalk; }, (0, fast_element_1.html) `
            <div class="card shadow-sm mb-4">
              <div class="card-body">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <div class="icon-circle bg-info text-white mr-3">
                      <i class="simple-icon-microphone"></i>
                    </div>
                    <div>
                      <h6 class="mb-0">${'avatar.voiceAgent'.t()}</h6>
                      <small class="text-muted">${'avatar.voiceAgent.description'.t()}</small>
                    </div>
                  </div>
                  <div>
                    ${(0, fast_element_1.when)(x => { var _a; return (_a = x.avatar) === null || _a === void 0 ? void 0 : _a.isVoiceAgent; }, (0, fast_element_1.html) `
                      <span class="badge badge-success badge-lg">
                        <i class="simple-icon-check mr-1"></i>${'common.yes'.t()}
                      </span>
                    `, (0, fast_element_1.html) `
                      <span class="badge badge-secondary badge-lg">
                        <i class="simple-icon-close mr-1"></i>${'common.no'.t()}
                      </span>
                    `)}
                  </div>
                </div>
              </div>
            </div>
          `)}

          
          <div class="card shadow-sm mb-4">
            <div class="card-header bg-light">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <i class="simple-icon-book-open mr-2 text-secondary"></i>
                  <h5 class="mb-0">${'avatar.preview.section.knowledge'.t()}</h5>
                </div>             
              </div>
            </div>
            <div class="card-body p-0">
              ${(0, fast_element_1.when)(x => { var _a; return ((_a = x.avatar) === null || _a === void 0 ? void 0 : _a.knowledgeEntries) && x.avatar.knowledgeEntries.length > 0; }, (0, fast_element_1.html) `
                      
                      
                      <div class="table-responsive">
                        <table class="table table-sm table-hover mb-0">
                          <thead class="thead-light">
                            <tr>
                              <th>${'knowledge.title'.t()}</th>
                              <th>${'file.ext'.t()}</th>
                              <th>${'file.size'.t()}</th>
                              <th>${'knowledge.description'.t()}</th>
                              <th>${'knowledge.tags'.t()}</th>
                              <th>${'knowledge.group'.t()}</th>
                              <th>${'knowledge.native'.t()}</th>
                              <th>${'knowledge.ragStatus'.t()}</th>
                              <th>${'knowledge.creator'.t()}</th>
                              <th>${'resource.active'.t()}</th>
                            </tr>
                          </thead>
                          <tbody>
                            ${(0, fast_element_1.repeat)(x => x.avatar.knowledgeEntries, (0, fast_element_1.html) `
                              <tr>
                                <td>
                                  <strong>${x => x.title}</strong>
                                </td>
                                <td>
                                  <span class="badge badge-info">${(x, c) => c.parent.fileBadge(x)}</span>
                                </td>
                                <td>
                                  ${(0, fast_element_1.when)(x => x.file, (0, fast_element_1.html) `${x => { var _a; return (((_a = x.file) === null || _a === void 0 ? void 0 : _a.size) / 1024 / 1024).toFixed(2); }}MB`, (0, fast_element_1.html) `-`)}
                                </td>
                                <td>
                                  <span class="text-muted">
                                    ${x => x.description ? (x.description.length > 50 ? x.description.substring(0, 50) + '...' : x.description) : '-'}
                                  </span>
                                </td>
                                <td>
                                  ${(0, fast_element_1.when)(x => x.tags && x.tags.length > 0, (0, fast_element_1.html) `
                                    ${(0, fast_element_1.repeat)(x => x.tags, (0, fast_element_1.html) `
                                      <span class="badge badge-secondary badge-sm mr-1">${x => x}</span>
                                    `)}
                                  `, (0, fast_element_1.html) `
                                    <span class="text-muted">-</span>
                                  `)}
                                </td>
                                <td>
                                  <span class="text-muted">
                                    ${x => x.knowledgeGroup ? x.knowledgeGroup.name : '-'}
                                  </span>
                                </td>
                                <td>
                                  ${(0, fast_element_1.when)(x => x.native, (0, fast_element_1.html) `
                                    <span class="badge badge-warning badge-sm">Native</span>
                                  `, (0, fast_element_1.html) `
                                    <span class="text-muted">-</span>
                                  `)}
                                </td>
                                <td>
                                  ${(0, fast_element_1.when)(x => x.ragStatus, (0, fast_element_1.html) `
                                    <span class="badge badge-sm badge-${x => x.ragStatus === 'COMPLETED' ? 'success' : x.ragStatus === 'PROCESSING' ? 'info' : x.ragStatus === 'FAILED' ? 'danger' : 'secondary'}">
                                      ${x => ('knowledge.ragStatus.' + x.ragStatus).t()}
                                    </span>
                                  `, (0, fast_element_1.html) `
                                    <span class="text-muted">-</span>
                                  `)}
                                </td>
                                <td>
                                  <span class="text-muted">
                                    ${x => x.creator ? x.creator.name : '-'}
                                  </span>
                                </td>
                                <td>
                                  <span class="badge badge-sm badge-${x => x.active !== false ? 'success' : 'danger'}">
                                    ${x => x.active !== false ? 'common.active'.t() : 'common.inactive'.t()}
                                  </span>
                                </td>
                              </tr>
                            `)}
                          </tbody>
                        </table>
              `, (0, fast_element_1.html) `
                <div class="text-center py-5 text-muted">
                  <i class="simple-icon-book-open" style="font-size: 3rem; margin-bottom: 1rem; opacity: 0.5;"></i>
                  <p class="mb-0">${'avatar.preview.knowledge.none_selected'.t()}</p>
                </div>
              `)}
            </div>
          </div>

          
          <div class="row mb-4">
            
            <div class="col-md-6 mb-3">
              <div class="card shadow-sm h-100">
                <div class="card-body text-center">
                  <div class="mb-3">
                    <i class="simple-icon-globe text-info" style="font-size: 2rem;"></i>
                  </div>
                  <h6 class="card-title">${'avatar.common'.t()}</h6>
                  <div class="mb-2">
                    ${(0, fast_element_1.when)(x => { var _a; return (_a = x.avatar) === null || _a === void 0 ? void 0 : _a.common; }, (0, fast_element_1.html) `
                      <span class="badge badge-info badge-lg">${'common.common'.t()}</span>
                    `, (0, fast_element_1.html) `
                      <span class="text-muted">-</span>
                    `)}
                  </div>
                  <small class="text-muted">${'avatar.common.help'.t()}</small>
                </div>
              </div>
            </div>
            
            
            <div class="col-md-6 mb-3">
              <div class="card shadow-sm h-100">
                <div class="card-body text-center">
                  <div class="mb-3">
                    <i class="simple-icon-power text-${x => { var _a; return ((_a = x.avatar) === null || _a === void 0 ? void 0 : _a.active) ? 'success' : 'danger'; }}" style="font-size: 2rem;"></i>
                  </div>
                  <h6 class="card-title">${'avatar.active'.t()}</h6>
                  <div>
                    ${(0, fast_element_1.when)(x => { var _a; return (_a = x.avatar) === null || _a === void 0 ? void 0 : _a.active; }, (0, fast_element_1.html) `
                      <span class="badge badge-success badge-lg">
                        <i class="simple-icon-check mr-1"></i>${'common.active'.t()}
                      </span>
                    `, (0, fast_element_1.html) `
                      <span class="badge badge-danger badge-lg">
                        <i class="simple-icon-close mr-1"></i>${'common.inactive'.t()}
                      </span>
                    `)}
                  </div>
                </div>
              </div>
            </div>
          </div>

          
          <div class="card shadow-sm mb-4">
            <div class="card-header bg-light">
              <div class="d-flex align-items-center">
                <i class="simple-icon-bubbles mr-2 text-secondary"></i>
                <h5 class="mb-0">${'avatar.preview.section.conversations'.t()}</h5>
              </div>
            </div>
            <div class="card-body p-0">
              ${(0, fast_element_1.when)(x => x.conversationsLoading, (0, fast_element_1.html) `
                <div class="text-center py-4">
                  <app-loader block="true" width="20" height="20"></app-loader>
                </div>
              `)}
              ${(0, fast_element_1.when)(x => !x.conversationsLoading && x.conversations.length > 0, (0, fast_element_1.html) `
                <div class="conversations-list">
                  ${(0, fast_element_1.repeat)(x => x.conversations, (0, fast_element_1.html) `
                    <div class="conversation-item d-flex align-items-center justify-content-between px-3 py-2"
                         @click="${(conv, c) => c.parent.goToConversation(conv)}">
                      <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
                        <i class="simple-icon-bubble mr-2 text-muted"></i>
                        <span class="text-truncate">${conv => conv.title || 'avatar.preview.conversations.untitled'.t()}</span>
                      </div>
                      <small class="text-muted ml-2 flex-shrink-0">
                        ${(conv, c) => conv.lastActivity ? c.parent.formatDate(conv.lastActivity) : ''}
                      </small>
                    </div>
                  `)}
                </div>
              `)}
              ${(0, fast_element_1.when)(x => !x.conversationsLoading && x.conversations.length === 0, (0, fast_element_1.html) `
                <div class="text-center py-4 text-muted">
                  <i class="simple-icon-bubbles" style="font-size: 2rem; margin-bottom: 0.5rem; opacity: 0.5;"></i>
                  <p class="mb-0">${'avatar.preview.conversations.empty'.t()}</p>
                </div>
              `)}
            </div>
          </div>
          
        `, (0, fast_element_1.html) `
          <div class="alert alert-info" role="alert">
            <i class="simple-icon-info mr-2"></i>
            ${'avatar.preview.no_data'.t()}
          </div>
        `)}
      </div>
    </div>
  </div>
  ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `<app-loader></app-loader>`)}
</div>`;
require("./styles/layout.scss");
const styles = T.css `.avatar-preview-page .top-right-button-container {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
}
.avatar-preview-page .icon-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
}
.avatar-preview-page .card {
  border: none;
  border-radius: 12px;
  transition: all 0.3s ease;
}
.avatar-preview-page .card.shadow-sm {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.avatar-preview-page .card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}
.avatar-preview-page .card .card-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px 12px 0 0;
}
.avatar-preview-page .card .card-header.bg-primary {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  border: none;
}
.avatar-preview-page .badge {
  font-weight: 500;
  padding: 0.5em 0.8em;
  border-radius: 6px;
}
.avatar-preview-page .badge.badge-lg {
  font-size: 0.95rem;
  padding: 0.6em 1em;
}
.avatar-preview-page .badge.badge-sm {
  font-size: 0.75rem;
  padding: 0.25em 0.6em;
}
.avatar-preview-page .bg-light-success {
  background-color: rgba(40, 167, 69, 0.1) !important;
  border: 1px solid rgba(40, 167, 69, 0.2);
}
.avatar-preview-page .bg-light-danger {
  background-color: rgba(220, 53, 69, 0.1) !important;
  border: 1px solid rgba(220, 53, 69, 0.2);
}
.avatar-preview-page img {
  transition: all 0.3s ease;
}
.avatar-preview-page img:hover {
  transform: scale(1.02);
}
.avatar-preview-page .table {
  border-radius: 8px;
  overflow: hidden;
}
.avatar-preview-page .table th {
  background-color: #f8f9fa;
  border-top: none;
  font-weight: 600;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  padding: 1rem 0.75rem;
}
.avatar-preview-page .table td {
  vertical-align: middle;
  padding: 0.75rem;
  border-color: rgba(0, 0, 0, 0.05);
}
.avatar-preview-page .table tbody tr:hover {
  background-color: rgba(0, 123, 255, 0.05);
}
.avatar-preview-page h1 {
  font-weight: 700;
  color: #2c3e50;
}
.avatar-preview-page h3, .avatar-preview-page h4, .avatar-preview-page h5 {
  font-weight: 600;
  color: #495057;
}
.avatar-preview-page .text-zero {
  font-size: 0;
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.avatar-preview-page .card {
  animation: fadeInUp 0.5s ease-out;
}
.avatar-preview-page .conversations-list {
  max-height: 400px;
  overflow-y: auto;
}
.avatar-preview-page .conversations-list .conversation-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.avatar-preview-page .conversations-list .conversation-item:last-child {
  border-bottom: none;
}
.avatar-preview-page .conversations-list .conversation-item:hover {
  background-color: rgba(0, 123, 255, 0.05);
}`;
const shadowOptions = { "mode": "open" };
let AvatarPreview = class AvatarPreview extends client_1.RWSViewComponent {
    constructor(popupService) {
        super();
        this.popupService = popupService;
        this.loading = false;
        this.avatarId = null;
        this.avatar = null;
        this.conversations = [];
        this.conversationsLoading = false;
    }
    get isUserSuperAdmin() {
        var _a;
        return ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN;
    }
    get isUserParentOrAdmin() {
        var _a, _b, _c;
        return ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN || ((_b = component_2.DefaultLayout.USER) === null || _b === void 0 ? void 0 : _b.role) === backendImport_1.UserRoles.PARENT_USER || ((_c = component_2.DefaultLayout.USER) === null || _c === void 0 ? void 0 : _c.role) === backendImport_1.UserRoles.ENTERPRISE;
    }
    async connectedCallback() {
        super.connectedCallback();
        this.avatarId = this.routeParams.id;
        if (this.avatarId) {
            await this.loadAvatar();
        }
    }
    async loadAvatar() {
        var _a;
        if (!this.avatarId)
            return;
        this.loading = true;
        try {
            const response = await this.apiService.back.get('avatar.get', {
                routeParams: { id: this.avatarId }
            });
            const avatarData = response.data;
            if (avatarData) {
                this.avatar = avatarData;
                await this.loadConversations();
            }
        }
        catch (e) {
            (_a = this.notifyService) === null || _a === void 0 ? void 0 : _a.notify('avatar.preview.error.load_failed'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    async loadConversations() {
        if (!this.avatarId)
            return;
        this.conversationsLoading = true;
        try {
            const response = await this.apiService.back.get('conversation.list', {
                queryParams: {
                    avatar_id: this.avatarId,
                    per_page: '20'
                }
            });
            if (response && response.success && Array.isArray(response.data)) {
                this.conversations = response.data;
            }
        }
        catch (e) {
            console.error('Error loading avatar conversations:', e);
        }
        finally {
            this.conversationsLoading = false;
        }
    }
    getSelectedVoiceLabel() {
        var _a;
        if (!((_a = this.avatar) === null || _a === void 0 ? void 0 : _a.voice))
            return 'avatar.preview.voice.not_selected'.t();
        const voiceOption = (0, voices_helper_1.getVoiceById)(this.avatar.voice);
        return voiceOption.nameKey.t();
    }
    back() {
        component_1.SiteMenu.goto.bind(this)('/avatar/list');
    }
    edit() {
        if (this.avatarId) {
            component_1.SiteMenu.goto.bind(this)(`/avatar/form/${this.avatarId}`);
        }
    }
    goToConversation(conversation) {
        component_1.SiteMenu.goto.bind(this)(`/conversation/preview/${conversation.id}`);
    }
    formatDate(date) {
        if (!date)
            return '';
        return console_1.DateUtils.create(date).format('yyyy-MM-dd HH:mm');
    }
    fileBadge(knowledge) {
        if (knowledge.contentType === 'text') {
            return 'text';
        }
        if (knowledge.contentType === 'link') {
            return 'link';
        }
        if (!(knowledge === null || knowledge === void 0 ? void 0 : knowledge.file)) {
            return 'n/a';
        }
        ;
        return knowledge.file.mimeType.split('/').pop();
    }
};
exports.AvatarPreview = AvatarPreview;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], AvatarPreview.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], AvatarPreview.prototype, "avatarId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof backendImport_1.IAvatar !== "undefined" && backendImport_1.IAvatar) === "function" ? _b : Object)
], AvatarPreview.prototype, "avatar", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], AvatarPreview.prototype, "conversations", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], AvatarPreview.prototype, "conversationsLoading", void 0);
exports.AvatarPreview = AvatarPreview = __decorate([
    (0, client_1.RWSView)('avatar-preview', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object])
], AvatarPreview);
AvatarPreview.defineComponent();
